import type { QueryOptions } from '@tanstack/react-query';

import { http } from '@/api/instance';
import { getQueryParameters } from '@/api/query';

export const kpiApi = {
  list: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<KpiDetail>>('/api/info/kpi', { params }).then(({ data }) => data),
  listOverall: ({ ...params }: Record<string, string | number>) =>
    http.get<ListResultsPageSize<KpiOverall>>('/api/info/kpi/overall', { params }).then(({ data }) => data),
  create: (data: KpiCreatePayload) => http.post('/api/add/kpi', { data }),
  update: (data: UpdateKpiPayload) => http.patch<unknown>(`/api/edit/kpi`, { data }),
  updateCompany: (data: UpdateKpiCompanyPayload) => http.patch<unknown>(`/api/edit/kpi_comp`, { data }),
  updateSaleAgency: (data: UpdateKpiSaleAgencyPayload) => http.patch<unknown>(`/api/edit/kpi_sa`, { data }),

  company: ({ ...params }: Record<string, string | number>) =>
    http.get<ListData<KpiCompany>>('/api/info/kpi_comp', { params }).then(({ data }) => data),
  saleAgency: ({ ...params }: Record<string, string | number>) =>
    http.get<ListData<KpiSaleAgency>>('/api/info/kpi_sa', { params }).then(({ data }) => data),
};

export const kpiQuery = {
  list: (params: KpiDetailParams) => {
    return {
      queryKey: ['GetKpiDetail', params] as const,
      queryFn: () => kpiApi.list(params),
    } as const satisfies QueryOptions;
  },
  listOverall: (params: QueryParams<Partial<SearchFormData>>) => {
    return {
      queryKey: ['GetKpiOverall', params] as const,
      queryFn: () => kpiApi.listOverall(getQueryParameters(params)),
    } as const satisfies QueryOptions;
  },
  companyKpi: (params: KpiDetailParams) => {
    return {
      queryKey: ['GetKpiCompany', params] as const,
      queryFn: () => kpiApi.company(params),
    } as const satisfies QueryOptions;
  },
  saleAgency: (params: KpiDetailParams) => {
    return {
      queryKey: ['GetKpiSaleAgency', params] as const,
      queryFn: () => kpiApi.saleAgency(params),
    } as const satisfies QueryOptions;
  },
};
